/**
 * @generated SignedSource<<1c618b5a817cabfee2e862f28eeba5bc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type sharedMessageHelpers_activePromotion$data = {
  readonly promotionMeta: {
    readonly customBannerMessage: boolean | null;
    readonly desktopBannerMessage: string | null;
    readonly desktopBannerCta: string | null;
    readonly mobileBannerMessage: string | null;
    readonly mobileBannerCta: string | null;
  } | null;
  readonly " $fragmentType": "sharedMessageHelpers_activePromotion";
};
export type sharedMessageHelpers_activePromotion$key = {
  readonly " $data"?: sharedMessageHelpers_activePromotion$data;
  readonly " $fragmentSpreads": FragmentRefs<"sharedMessageHelpers_activePromotion">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "sharedMessageHelpers_activePromotion"
};

(node as any).hash = "7c8db323227e2cde65105076d6772d27";

export default node;
